<template>
  <div class="wrap">
    <div class="header">
      <div class="h1">Co-branded landing</div>
      <div class="h2">Pick a layout</div>
      <div class="chips">
        <span class="chip">lar={{ larFromQuery || "none" }}</span>
        <span class="chip">rid={{ ridFromQuery || "realtor-demo" }}</span>
      </div>
    </div>

    <div class="grid">
      <a class="card" :href="go('classic')">
        <div class="cardTitle">Classic</div>
        <div class="cardText">Two cards + info section</div>
      </a>

      <a class="card" :href="go('split')">
        <div class="cardTitle">Split Hero</div>
        <div class="cardText">Hero left, actions right</div>
      </a>

      <a class="card" :href="go('fullbleed')">
        <div class="cardTitle">Full Bleed</div>
        <div class="cardText">Big image header + sections</div>
      </a>

      <a class="card" :href="go('minimal')">
        <div class="cardTitle">Minimal</div>
        <div class="cardText">Ultra clean, one column</div>
      </a>

      <a class="card" :href="go('stack')">
        <div class="cardTitle">Card Stack</div>
        <div class="cardText">Mobile-first stacked cards</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoBrandThemeLanding",
  data() {
    return { larFromQuery: "", ridFromQuery: "" };
  },
  methods: {
    readQuery() {
      const p = new URLSearchParams(window.location.search);
      this.larFromQuery = p.get("lar") || "";
      this.ridFromQuery = p.get("rid") || "realtor-demo";
    },
    go(theme) {
      const u = new URL(window.location.origin + "/cobrand/" + theme);
      if (this.larFromQuery) u.searchParams.set("lar", this.larFromQuery);
      if (this.ridFromQuery) u.searchParams.set("rid", this.ridFromQuery);
      return u.toString();
    }
  },
  mounted() {
    this.readQuery();
  }
};
</script>

<style scoped>
.wrap {
  min-height: 100vh;
  padding: 26px 18px 40px;
  background: #0b1220;
  color: #e5e7eb;
}
.header {
  max-width: 980px;
  margin: 0 auto 18px;
}
.h1 {
  font-size: 28px;
  font-weight: 800;
}
.h2 {
  margin-top: 6px;
  color: #9ca3af;
}
.chips {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 12px;
}
.chip {
  border: 1px solid #22304b;
  background: #111a2e;
  padding: 6px 10px;
  border-radius: 999px;
  color: #9ca3af;
  font-size: 12px;
}
.grid {
  max-width: 980px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.card {
  border: 1px solid #22304b;
  background: #111a2e;
  border-radius: 18px;
  padding: 16px;
  text-decoration: none;
  color: #e5e7eb;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.cardTitle {
  font-weight: 800;
  font-size: 16px;
}
.cardText {
  color: #9ca3af;
  font-size: 13px;
  margin-top: 10px;
}
@media (max-width: 900px) {
  .grid { grid-template-columns: 1fr; }
}
</style>